<template>
<v-window v-model='step' vertical >
  <v-window-item v-for='step in steps' :key='step.id' >
    <slot :name='`step-${step.id}`' ></slot>
  </v-window-item>
</v-window>
</template>
<script>
export default {
  name: 'MobileStepLayout',
  props: {
    steps: { type: Array, default: () => { return [{id: 0}, {id: 1}, {id: 2}] } },
    step: { type: Number, default: 0 }
  }
}
</script>



// WEBPACK FOOTER //
// MobileStepLayout.vue?796ac843